import axios from 'axios';

var baseUrlInit = process.env.REACT_APP_API_URL;

//get Current URL
export default axios.create({baseURL: baseUrlInit});
